export type CommissionStatus = 'pending' | 'approved' | 'paid' | 'reversed';

export interface CommissionEntryRow {
  id: string;
  sales_rep_id: string;
  sales_rep_name: string | null;
  is_primary_rep: boolean;
  share_pct: number;
  entity_type: 'project' | 'subscription';
  entity_id: string;
  entity_title: string | null;
  client_id: string;
  client_name: string;
  lead_source: 'cold_new_client' | 'inbound_new_client' | 'existing_client';
  commission_base: string;
  commission_rate: string;
  calculated_amount: string;
  override_amount: string | null;
  override_reason: string | null;
  approved_amount: string | null;
  status: CommissionStatus;
  reverses_entry_id: string | null;
  sale_date: string;
  commission_period_start: string;
  commission_period_end: string;
  notes: string | null;
  created_at: string;
  approved_at: string | null;
  approved_by_user_id: string | null;
}

export interface CommissionGroupRow {
  sales_rep_id: string;
  sales_rep_name: string | null;
  entry_count: number;
  total_calculated: string;
  total_override: string;
  total_approved: string;
  all_approved: boolean;
  any_pending: boolean;
}

export interface PeriodInfo {
  start: string;
  end: string;
  label: string;
}

export interface CommissionFilters {
  period: string; // "YYYY-MM"
  status: CommissionStatus[];
  salesRepIds: string[];
  entityTypes: Array<'project' | 'subscription'>;
}

export function defaultPeriodLabel(now: Date = new Date()): string {
  const y = now.getFullYear();
  const m = now.getMonth();
  const d = now.getDate();
  // Period label = month containing the 21st of the period end.
  // If today is ≤21, the "current" period ends this month (label = this month).
  // If today is ≥22, the "current" period ends next month (label = next month).
  const labelM = d <= 21 ? m : (m + 1) % 12;
  const labelY = d <= 21 || m < 11 ? y : y + 1;
  return `${labelY}-${String(labelM + 1).padStart(2, '0')}`;
}

export function shiftPeriod(label: string, delta: number): string {
  const [y, m] = label.split('-').map((n) => Number.parseInt(n, 10));
  if (!y || !m) return label;
  const date = new Date(Date.UTC(y, m - 1 + delta, 15));
  return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}`;
}

export function formatPeriodDanish(info: PeriodInfo): string {
  const months = [
    'januar',
    'februar',
    'marts',
    'april',
    'maj',
    'juni',
    'juli',
    'august',
    'september',
    'oktober',
    'november',
    'december',
  ];
  const [y, m] = info.label.split('-').map((n) => Number.parseInt(n, 10));
  if (!y || !m) return info.label;
  const monthName = months[m - 1];
  const startParts = info.start.split('-');
  const endParts = info.end.split('-');
  const startDay = Number(startParts[2]);
  const startMonthIdx = Number(startParts[1]);
  const endDay = Number(endParts[2]);
  const endMonthIdx = Number(endParts[1]);
  const startMonth = months[startMonthIdx - 1];
  const endMonth = months[endMonthIdx - 1];
  return `${monthName} ${y} (${startDay}. ${startMonth} → ${endDay}. ${endMonth})`;
}
